import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { toast } from 'react-toastify';
import ResponsiveTable from "../../components/ResponsiveTable";
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import moment from "moment"

export default function ExpensesList() {
  const navigate = useNavigate();
  const [supplierOption, setSupplierOption] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [expensesTotal, setExpensesTotal] = useState(0);
  const [categoryOption, setcategoryOption] = useState([])
  const [filters, setFilters] = useState({
    start: moment().subtract(30, "days").startOf('day').format("YYYY-MM-DD"),
    end: moment().add(1, "days").format("YYYY-MM-DD"),
    category_id: null,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const getExpensesData = () => {
    axios.get("/expenses", {
      params: {
        start_date: filters.start,
        end_date: filters.end,
        category_id: filters.category_id,
      }
    }).then((res) => {
      setFiltered(res.data);
      const total = res?.data?.reduce((sum, r) => sum + Number(r.amount), 0);
      setExpensesTotal(total)
    });
  }
  const getCategoryData = () => {
    axios.get("/expenses/expense-categories").then((res) => {
      const categoryOption = res.data.map(item => ({ value: item.id, label: item.name }));
      setcategoryOption(categoryOption);
    })
      .catch(err => toast.error(err.message || `Error`));
  }
  useEffect(() => {
    getExpensesData()
    getCategoryData()
  }, []);

  useEffect(() => {
    getExpensesData()
  }, [filters]);

  const capitalizeFirstLetter = (word) => {
    if (!word || typeof word !== "string") return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  };
  const handleExportPDF = () => {
    const pdfContent = filtered.map(s => ({
      ID: s.id,
      Customer: s.customer_name,
      Items: s.items?.map(i => i.name).join(", "),
      Total: s.total,
      Date: s.sale_date,
      Status: s.status,
      Payment: s.payment_status
    }));
    import('jspdf').then(jsPDF => {
      import('jspdf-autotable').then(() => {
        const doc = new jsPDF.jsPDF();
        doc.autoTable({ head: [Object.keys(pdfContent[0]).filter(h => h !== 'actions')], body: pdfContent.map(obj => Object.entries(obj).filter(([k]) => k !== 'actions').map(([, v]) => v)) });

        const date = new Date().toISOString().slice(0, 10);
        const logo = new Image();
        logo.src = "/logo-dark.png";
        logo.onload = () => {
          doc.addImage(logo, "PNG", 10, 10, 30, 10);
          doc.setFontSize(14);
          doc.text("Sales Report", 50, 17);
          doc.autoTable({
            startY: 25,
            head: [Object.keys(pdfContent[0]).filter(h => h !== 'actions')],
            body: pdfContent.map(obj => Object.entries(obj).filter(([k]) => k !== 'actions').map(([, v]) => v))
          });
          doc.save(`Sales_Report_${date}.pdf`);
        };

      });
    });
  }

  const actions = [
    { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
    { divider: true },
    { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
  ];
  const handleActionClick = (action, row) => {
    switch (action) {
      case "edit":
        navigate(`/expenses/edit/${row.id}`);
        break;
      case "delete":
        if (window.confirm("Are you sure you want to delete this Expenses?")) {
          axios.delete(`/expenses/${row.id}`).then((res) => {
            if (res.data.success === true) {
              toast.success(res.data.message || "Delete Expenses Successfully")
              getExpensesData()
            }

          })
            .catch(err => toast.error(err.message || `Error`));
        }
        break;
      default:
        break;
    }
  };
  const handleDownload = (type) => {
    const url = `${apiBaseUrl}/purchases/export/${type}`;
    window.open(url, "_blank");
  };
  const columns = [
    {
      header: "Date", accessor: "expense_date",
      render: (value, row) => <span>{moment(value).format("DD/MM/YYYY")}</span>
    },
    { header: "Category", accessor: "category_name" },
    { header: "Bank Name", accessor: "bank_name" },
    {
      header: "Amount", accessor: "amount",
      render: (value, row) => <span className="text-red-500">{value} BDT</span>
    },
    { header: "Note", accessor: "note" },
  ];

  return (
    <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
      <div className="w-full">
        <ExportButtons title="Expenses List" onDownload={handleDownload} />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="flex items-center rounded-md">
            <Flatpickr
              style={{
                backgroundColor: "#fff",
                opacity: "1",
                padding: "9px 12px",
              }}
              // options={{
              //   dateFormat: "d-m-Y"
              // }}
              value={filters.start}
              id="date-time-picker"
              className="form-control"
              onChange={(date) => setFilters(f => ({ ...f, start: moment(date[0]).format('YYYY-MM-DD') }))}
            />
          </div>
          <div className="flex items-center rounded-md">
            <Flatpickr
              style={{
                backgroundColor: "#fff",
                opacity: "1",
                padding: "9px 12px",
              }}
              // options={{
              //   dateFormat: "d-m-Y",
              // }}
              value={filters.end}
              id="date-time-picker"
              className="form-control"
              onChange={(date) => setFilters(f => ({ ...f, end: moment(date[0]).format('YYYY-MM-DD') }))}
            />
          </div>
          <div className="flex items-center rounded-md">
            <Select
              name="category"
              onChange={e => setFilters(f => ({ ...f, category_id: e.value }))}
              options={categoryOption}
              placeholder="Select Category"
              className="w-full"
              classNamePrefix="react-select"
              maxMenuHeight={150}
            />
          </div>
        </div>
        <ResponsiveTable
          columns={columns}
          data={filtered}
          showActions
          actionButtons={actions}
          onActionClick={handleActionClick}
        />
        <div className='flex gap-4 max-sm:gap-2 px-2'>
          <p className=' font-bold'>Total Expenses: <span className=' text-red-600 font-semibold'>{expensesTotal.toFixed(2)}</span></p>
        </div>
      </div>
    </div>
  );
}